







































import { Component, Vue } from "vue-property-decorator";
import AccountDataPanel from "@/components/settings/AccountDataPanel.vue";
import ChangePasswordPanel from "@/components/settings/ChangePasswordPanel.vue";
import TwoFactorAuthPanel from "@/components/settings/TwoFactorAuthPanel.vue";

@Component({
  components: { AccountDataPanel, ChangePasswordPanel, TwoFactorAuthPanel }
})
export default class UserSettings extends Vue {
  activeSection: "account" | "password" | "mfa" = "account";

  get lang() {
    return this.$store.state.lang.data;
  }
}
